import { ChangePasswordDetails } from "../types/resetPasswordTypes";

export const changeUserPasswordInitialValues: ChangePasswordDetails = {
  password: "",
  confirmPassword: "",
};
